// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__29YM_","col":"styles_col__2f63q","fulfillmentStatus":"styles_fulfillmentStatus__3A0Iv","emailCol":"styles_emailCol__2lQHl"};